import { Extension } from '@tiptap/core'
import { sanitizeClassName, sanitizeHeadingId } from './htmlAttrs'

const JohkuHtmlAttrs = Extension.create({
  name: 'johkuHtmlAttrs',

  addGlobalAttributes() {
    return [
      {
        types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'listItem', 'div'],
        attributes: {
          class: {
            default: null,
            parseHTML: (element) => sanitizeClassName(element.getAttribute('class')),
            renderHTML: (attributes) => {
              const className = sanitizeClassName(attributes.class)
              if (!className) {
                return {}
              }
              return { class: className }
            },
          },
        },
      },
      {
        types: ['heading'],
        attributes: {
          id: {
            default: null,
            parseHTML: (element) => sanitizeHeadingId(element.getAttribute('id')),
            renderHTML: (attributes) => {
              const id = sanitizeHeadingId(attributes.id)
              if (!id) {
                return {}
              }
              return { id }
            },
          },
        },
      },
    ]
  },
})

export default JohkuHtmlAttrs
